export default function general() {
  return [
    'textGeneral',
    'header',
    'grid',
    'columns',
    'googleMap',
    'navigation',
    'button',
    'socialMedia',
    'form',
    'accordion',
    // ------------- //
    'cardsTall',
    'cardsGeneral',
    'cardsWide',
    'cardsEvent',
    'cardsStep',
    'imageGallery',
    'imageGeneral',
    'table',
    'tabs',
    'audioPlayer',
    // ------------- //
    'textBlob',
    'modal',
    'carousel',
    'codeGeneral',
    'contentSlider',
    'countdown',
    'divider',
    'copyright',
    'footerNav',
    'videoPlayer',
    'youTubeVideo',
    'progressBar',
    'textSwapper',
    // ------------- //
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/general.js